<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="solid" (click)="cancel()">
        <ion-icon slot="start" name="close-circle-outline"></ion-icon>
        {{ 'General.Cancel' | translate }}
      </ion-button>
    </ion-buttons>
    <ion-title class="modal-title" [ngClass]="{'adjustedTitleFont': settingService.configuration.uIoptions?.homePageOption == 10}">{{ title | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card>
    <ion-item lines="none">
      <ion-label>
        <h2>{{ 'Checkout.PersonnalInformation' | translate }}</h2>
      </ion-label>
      <ion-note slot="end"><span style="color:red;">*</span> {{ 'General.RequiredFields' | translate }}
    </ion-note>
  </ion-item>
  <store-checkout-personal-info-form [submitted]="submitted" (onSubmit)="onPersonalInfoFormChanged($event)"></store-checkout-personal-info-form>

  <ion-item lines="none">
    <ion-label>
      <h2 class="hidden-sm-up">{{ 'Checkout.PaymentInformation' | translate }}</h2>
      <h2 class="hidden-xs-up">{{ 'Checkout.PaymentInformationslicedup1' | translate }}</h2>
      <h2 class="hidden-xs-up">{{ 'Checkout.PaymentInformationslicedup2' | translate }}</h2>
    </ion-label>
    <ion-note slot="end" style="padding: 0px;"><span style="color:red;"></span> <img class="hidden-sm-up" style="height:50px;" [src]="secureUrl"><img class="hidden-xs-up" style="height:25px;" [src]="secureUrl"></ion-note>
  </ion-item>
  <ion-item lines="none" class="important-message">
    <ion-icon name="alert-circle-outline" style="font-size:34pt; color:orange;"></ion-icon>
    <ion-label class="ion-text-wrap">
      <h2 class="ResizedSubcategoryName">{{ 'General.Important' | translate | uppercase }}</h2>
      <p class="importantMessageResize"> {{ 'Checkout.ImportantMessage' | translate }} {{ 'Checkout.MerchandRights' | translate }} {{ order._deliveryType == 'delivery' && shippingAddress && store.strictBillingAddress ? ('Checkout.StrictBillingAddressMessage' | translate) : '' }}</p>

    </ion-label>
  </ion-item>

  <ion-grid style="width:100%">
    <ion-row>
      <ion-col size="12">
        <h3 class="adjustedTipTitle">{{'Checkout.Tip' | translate}}</h3>
      </ion-col>
    </ion-row>
  </ion-grid>
  <store-checkout-tip-form [subTotal]="subTotal" [store]="store" [orderType]="order._deliveryType" (onSubmit)="onTipChanged($event)"></store-checkout-tip-form>

  <store-checkout-total (onShipping)="onShippingCalculated($event)" (onTotal)="onTotalChanged($event)" [store]="store" [order]="order" [options]="totalOptions"></store-checkout-total>

  @if (!settingService.configuration.hideGiftProgram) {
    <store-checkout-gift-card-form [freeDelivery]="freeDelivery" [subtotal]="subTotal" [deliveryPrice]="deliveryPrice" [total]="total" [storeId]="order.store.id" (onSubmit)="onGiftCardChange($event)"></store-checkout-gift-card-form>
  }

  @if (!settingService.configuration.hideECouponProgram) {
    <app-checkout-coupon-form (closeModal)="searchCoupon($event)" (onSubmit)="getDiscountAmount($event)" [order]="order" [total]="total" [subtotal]="subTotal" [storeId]="order.store.id"></app-checkout-coupon-form>
  }






  @if (store.cloverPaymentInfo != null) {
    <form action="/charge" method="post" id="payment-form">
      <!-- this form contains the card data fields -->
        
      <div style="display: flex; max-height: 35px;">
        <div style="padding: 5px; max-width: 300px;" class="custom-form-group">
            <div id="card-name" class="card-name"></div>
            <div class="input-errors" id="card-name-errors" role="alert"></div>
        </div>
        <div style="padding: 5px" class="custom-form-group"></div>
      </div>

      <div style="display: flex; max-height: 35px;">
        <div style="padding: 5px; max-width: 300px;" class="custom-form-group">
            <div id="card-number" class="card-number"></div>
            <div class="input-errors" id="card-number-errors" role="alert"></div>
        </div>            


        <div style="padding: 5px; max-width: 100px;" class="custom-form-group">
            <div id="card-date" class="field third-width"></div>
            <div class="input-errors" id="card-date-errors" role="alert"></div>
        </div>

        <div style="padding: 5px; max-width: 125px;" class="custom-form-group">
          <div id="card-cvv" class="field third-width"></div>
          <div class="input-errors" id="card-cvv-errors" role="alert"></div>
        </div>
      </div>

      <div style="display: flex; max-height: 35px; margin-bottom: 20px;">              
        <div style="padding: 5px; max-width: 125px;" class="custom-form-group">
            <div id="card-postal-code" class="field third-width"></div>
            <div class="input-errors" id="card-postal-code-errors" role="alert"></div>
        </div>

          <div style="display: flex; justify-content: center; margin-top: 5px;" class="button-container">
            <ion-button type="submit" [disabled]="cloverTokenId != null"  id="payment-request-button" style="margin-bottom: 20px">{{ "Checkout.SubmitCard" | translate | uppercase }}</ion-button>
        </div>
      </div>
      <div id="card-response" role="alert"></div>            
      <!--<div id="payment-request-button"></div>-->          
    </form>

    
  }







  @if ((!auth.isAuthenticated || (store.paymentRestriction && store.paymentRestriction.use3DSecure)) && !isGiftCardFullyCover && store.cloverPaymentInfo == null) {
    <shared-credit-card-form [submitted]="submitted" (onSubmit)="onGuestCreditCardChanged($event)"></shared-credit-card-form>
    <shared-address-postalcode [isReservation]="false" [skipProvinceValidation]="false" [submitted]="submitted" (onChange)="onBillingAddressChanged($event)" placeHolder="{{ 'CreditCard.BillingAddress' | translate }}"></shared-address-postalcode>
  }

  @if (auth.isAuthenticated && !isGiftCardFullyCover && (!store.paymentRestriction || !store.paymentRestriction.use3DSecure) && store.cloverPaymentInfo == null) {
    <account-credit-card-checkout (onCardSelected)="onMemberCreditCardChanged($event)" [submitted]="submitted" [storeId]="store.id"></account-credit-card-checkout>
  }

  @if (store.cloverPaymentInfo == null || (store.cloverPaymentInfo != null && cloverTokenId != null)) {
  <ion-item class="order-type-row">
    <ion-label class="ion-text-wrap">
      @if (order._deliveryType == 'delivery' && shippingAddress) {
        <p class="bigger-ion-text Textresized"> {{ 'Checkout.Delivery' | translate }} :
          <span class="inline-block">{{ shippingAddress.streetNumber }}  {{ shippingAddress.street }}, {{ shippingAddress.city }}, {{ shippingAddress.postalCode }}</span>
          @if (order.orderDate == null && order.orderTime == null) {
            <span><br/>{{('General.EstimatedTime' | translate)}} {{(estimatedTime | date: 'HH:mm')}}</span>
          }
          @if (order.orderDate || order.orderTime) {
            <span><br/>{{((order.orderDate == null ? 'Menu.Date.Today' : order.orderDate) | translate) + ' @ ' + ((order.orderTime == null ? (estimatedTime | date: 'HH:mm') : order.orderTime)) }}</span>
          }
        </p>
      }
      @if (order._deliveryType == 'shipping' && shippingAddress) {
        <p class="bigger-ion-text Textresized"> {{ 'Checkout.Shipping' | translate }} :
          <span class="inline-block">{{ shippingAddress.streetNumber }}  {{ shippingAddress.street }}, {{ shippingAddress.city }}, {{ shippingAddress.postalCode }}</span>
          @if (order.orderDate == null && order.orderTime == null) {
            <span><br/>{{('General.EstimatedTime' | translate)}} {{(estimatedTime | date: 'HH:mm')}}</span>
          }
          @if (order.orderDate || order.orderTime) {
            <span><br/>{{((order.orderDate == null ? 'Menu.Date.Today' : order.orderDate) | translate) + ' @ ' + ((order.orderTime == null ? (estimatedTime | date: 'HH:mm') : order.orderTime)) }}</span>
          }
        </p>
      }
      @if (order._deliveryType == 'pickup' && store) {
        <p class="bigger-ion-text Textresized">
          {{ 'Checkout.Pickup' | translate }} : {{ store.displayName}} -
          <span class="inline-block">{{ store.address.streetNumber }}  {{ store.address.street }}, {{ store.address.city }}, {{ store.address.postalCode }}</span>
          @if (order.orderDate == null && order.orderTime == null) {
            <span><br/>{{('General.EstimatedTime' | translate)}} {{(estimatedTime | date: 'HH:mm')}}</span>
          }
          @if (order.orderDate || order.orderTime) {
            <span><br/>{{((order.orderDate == null ? 'Menu.Date.Today' : order.orderDate) | translate) + ' @ ' + ((order.orderTime == null ? (estimatedTime | date: 'HH:mm') : order.orderTime)) }}</span>
          }
        </p>
      }
      @if (order._deliveryType == 'seat' && store && order._seatInfo) {
        <p class="bigger-ion-text Textresized">
          {{ 'Checkout.Seat' | translate }} : {{ store.displayName}}<br/>
          <span class="inline-block">{{ 'Checkout.Section' | translate }} {{ order._seatInfo.section }} - {{ 'Checkout.Row' | translate }} {{ order._seatInfo.row }} - {{ 'Checkout.Seat' | translate }} #{{ order._seatInfo.seatNumber }}</span>
          @if (order.orderDate == null && order.orderTime == null) {
            <span><br/>{{('General.EstimatedTime' | translate)}} {{(estimatedTime | date: 'HH:mm')}}</span>
          }
          @if (order.orderDate || order.orderTime) {
            <span><br/>{{((order.orderDate == null ? 'Menu.Date.Today' : order.orderDate) | translate) + ' @ ' + ((order.orderTime == null ? (estimatedTime | date: 'HH:mm') : order.orderTime)) }}</span>
          }
        </p>
      }
    </ion-label>
  </ion-item>


  <!-- <ion-item> Put that inside a component
  <ion-label  class="ion-text-wrap">
    {{ 'Checkout.SendNotification' | translate }}
  </ion-label>
  <ion-checkbox  (ionChange)="submitSendNotification()" id="sendNotification" color="primary" slot="start" checked></ion-checkbox>
</ion-item> -->
  @if (isDelivery && store.isDoorDashDrive) {
    <store-checkout-doordash-drive-form (onSubmit)="onSendNotificationChanged($event)"> </store-checkout-doordash-drive-form>
  }
  @if (isDelivery && store.isUberDirect) {
    <checkout-uber-direct-form [hasAlcohol]="hasAlcohol" (onSubmit)="onDeliveryOptionChanged($event)"></checkout-uber-direct-form>
  }
  <store-checkout-order-note-form [isDelivery]="isDelivery" (onSubmit)="onCheckoutNoteChange($event)"></store-checkout-order-note-form>
  @if (hasAlcohol) {
    <div class="alcohol-notice">
      {{ "Checkout.AlcoholItemNoticeText" | translate }}
    </div>
  }
  @if (store.askUtensils) {
    <div>
      <ion-item>
        <ion-checkbox (ionChange)="onUtensilsChange($event)" color="primary" slot="start"></ion-checkbox>
        <ion-label class="Textresized">{{ "Checkout.AskUtensils" | translate }}</ion-label>
      </ion-item>
    </div>
  }


  <store-checkout-terms-agreement-form (onSubmit)="onTermsAgreementChanged($event)"></store-checkout-terms-agreement-form>
  <!--[disabled]="!isFormValid"-->
  <!--<ion-item>
  <ion-label class="ion-text-wrap">
    <p style="color:red;"> {{ 'General.TemporaryOutOfService' | translate }}</p>
  </ion-label>
  </ion-item>-->

  <ion-button expand="block" [disabled]="clickedSubmitted || (!termsAgreement || (termsAgreement && !termsAgreement.agreement)) || underMinimumOrderValue()"  (click)="pay()">{{ 'General.Pay' | translate }}</ion-button>
}
</ion-card>
</ion-content>